import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, createBlock as _createBlock, withKeys as _withKeys, createSlots as _createSlots, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './back.png'
import _imports_1 from '@/assets/images/vi-en-logo.png'
import _imports_2 from '@/assets/images/vi-logo-3p.png'
import _imports_3 from '../qrcode.png'
import _imports_4 from '@/assets/images/certification-demo.png'
import _imports_5 from '@/assets/images/certification-tag.png'
import _imports_6 from '@/assets/images/service-qrcode2.png'
import _imports_7 from '@/assets/images/huawei.png'
import _imports_8 from '@/assets/images/vi-logo.png'


_pushScopeId("data-v-ac241436")
const _hoisted_1 = { style: {"height":"100%"} }
const _hoisted_2 = {
  key: 0,
  class: "login-in login-wechat"
}
const _hoisted_3 = { class: "wechat-con" }
const _hoisted_4 = { class: "wechat-title" }
const _hoisted_5 = { class: "wechat-scan" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "agreement" }
const _hoisted_8 = { style: {"display":"flex","flex-direction":"row"} }
const _hoisted_9 = {
  key: 1,
  class: "success"
}
const _hoisted_10 = {
  key: 1,
  class: "login-in"
}
const _hoisted_11 = {
  key: 0,
  class: "certification-header"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "返回",
  class: "back-icon"
}, null, -1)
const _hoisted_13 = {
  key: 1,
  class: "login-right_logo"
}
const _hoisted_14 = {
  key: 0,
  class: "logo-en"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "logo"
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "sign-in" }, "SIGN IN", -1)
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "vi-logo-welcome" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#434af9","font-size":"48px","font-weight":"bolder","font-style":"italic"} }, "w"),
  /*#__PURE__*/_createTextVNode("elcome ")
], -1)
const _hoisted_19 = { class: "vi-logo-welcome-name" }
const _hoisted_20 = {
  key: 1,
  src: _imports_2,
  alt: "logo"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "step-number" }, "1", -1)
const _hoisted_22 = { class: "step-title" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "step-number" }, "2", -1)
const _hoisted_24 = { class: "step-title" }
const _hoisted_25 = {
  key: 3,
  class: "div-login_tab"
}
const _hoisted_26 = { style: {"float":"left"} }
const _hoisted_27 = { style: {"float":"right"} }
const _hoisted_28 = { class: "verify-in" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = {
  key: 0,
  class: "verify-img"
}
const _hoisted_31 = ["src"]
const _hoisted_32 = { class: "verify-in" }
const _hoisted_33 = { style: {"color":"#434af9","cursor":"pointer","font-size":"12px"} }
const _hoisted_34 = { style: {"font-size":"12px","text-align":"center","padding":"8px 10px"} }
const _hoisted_35 = { style: {"font-weight":"500","line-height":"18px","text-align":"left"} }
const _hoisted_36 = { style: {"width":"272px","line-height":"18px","color":"#d3d3d8","text-align":"left","margin-top":"4px"} }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("img", {
  style: {"margin-top":"12px"},
  src: _imports_3,
  alt: ""
}, null, -1)
const _hoisted_38 = { key: 1 }
const _hoisted_39 = {
  key: 5,
  class: "certification-step"
}
const _hoisted_40 = { class: "form-item" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", { class: "icon-corpname" }, null, -1)
const _hoisted_42 = { class: "form-item" }
const _hoisted_43 = { class: "label-with-required" }
const _hoisted_44 = { class: "label-left" }
const _hoisted_45 = { class: "required" }
const _hoisted_46 = { class: "upload-wrapper" }
const _hoisted_47 = {
  key: 0,
  class: "upload-loading-container"
}
const _hoisted_48 = ["src"]
const _hoisted_49 = { class: "image-actions" }
const _hoisted_50 = {
  key: 2,
  class: "upload-content"
}
const _hoisted_51 = { class: "upload-left" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-circle-plus upload-icon" }, null, -1)
const _hoisted_53 = { class: "upload-text" }
const _hoisted_54 = { class: "upload-tip" }
const _hoisted_55 = { class: "upload-tip" }
const _hoisted_56 = { class: "upload-right" }
const _hoisted_57 = { class: "example-image-wrapper" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "certification-tag",
  alt: "角标"
}, null, -1)
const _hoisted_59 = { class: "form-item" }
const _hoisted_60 = { class: "label-left" }
const _hoisted_61 = {
  key: 0,
  class: "required"
}
const _hoisted_62 = {
  key: 1,
  class: "optional"
}
const _hoisted_63 = { class: "upload-wrapper" }
const _hoisted_64 = {
  key: 0,
  class: "upload-loading-container"
}
const _hoisted_65 = { class: "file-info" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-document file-icon" }, null, -1)
const _hoisted_67 = { class: "file-name" }
const _hoisted_68 = { class: "file-actions" }
const _hoisted_69 = {
  key: 2,
  class: "upload-content"
}
const _hoisted_70 = { class: "upload-left" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-circle-plus upload-icon" }, null, -1)
const _hoisted_72 = { class: "upload-text" }
const _hoisted_73 = { class: "upload-tip" }
const _hoisted_74 = { class: "upload-right" }
const _hoisted_75 = { class: "example-image-wrapper" }
const _hoisted_76 = ["src"]
const _hoisted_77 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "certification-tag",
  alt: "角标"
}, null, -1)
const _hoisted_78 = { style: {"margin-left":"10px"} }
const _hoisted_79 = {
  key: 0,
  style: {"padding":"0 2px"}
}
const _hoisted_80 = { style: {"padding":"0 2px"} }
const _hoisted_81 = {
  key: 0,
  class: "agree-msg"
}
const _hoisted_82 = {
  key: 6,
  style: {"font-size":"12px","margin-top":"30px","color":"#c4c9db"}
}
const _hoisted_83 = {
  key: 0,
  class: "reg"
}
const _hoisted_84 = { key: 0 }
const _hoisted_85 = { class: "reg" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"190px","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"width":"180px"},
    src: _imports_6,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"12px","text-align":"left","color":"#999","margin-top":"10px"} }, [
    /*#__PURE__*/_createElementVNode("i", { class: "el-icon el-icon-warning" }),
    /*#__PURE__*/_createTextVNode(" 本平台为企业提供专业化合作服务。若您是寻求AI数字化转型的企业伙伴，请扫描二维码开启专属商务咨询。 ")
  ])
], -1)
const _hoisted_87 = { style: {"color":"#434af9","cursor":"pointer"} }
const _hoisted_88 = { class: "reg-btn" }
const _hoisted_89 = { class: "huawei-title" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: _imports_7
}, null, -1)
const _hoisted_91 = { class: "desc" }
const _hoisted_92 = { class: "login-text" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("div", { class: "br" }, null, -1)
const _hoisted_94 = { class: "text" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("div", { class: "br" }, null, -1)
const _hoisted_96 = {
  key: 2,
  class: "login-in"
}
const _hoisted_97 = /*#__PURE__*/_createElementVNode("div", { class: "login-right_logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_8,
    alt: "logo"
  })
], -1)
const _hoisted_98 = { class: "div-login_tab" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-back" }, null, -1)
const _hoisted_100 = [
  _hoisted_99
]
const _hoisted_101 = { class: "span-login_psw" }
const _hoisted_102 = { class: "verify-in" }
const _hoisted_103 = { class: "verifyCodeBox" }
const _hoisted_104 = { class: "timeBox" }
const _hoisted_105 = {
  key: 3,
  class: "login-in"
}
const _hoisted_106 = { class: "title" }
const _hoisted_107 = { class: "title_content" }
const _hoisted_108 = { class: "register_btns" }
const _hoisted_109 = {
  key: 4,
  class: "login-in"
}
const _hoisted_110 = /*#__PURE__*/_createElementVNode("div", { class: "login-right_logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_8,
    alt: "logo"
  })
], -1)
const _hoisted_111 = { class: "div-login_tab" }
const _hoisted_112 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-back" }, null, -1)
const _hoisted_113 = [
  _hoisted_112
]
const _hoisted_114 = { class: "span-login_psw" }
const _hoisted_115 = { class: "preview-image-wrapper" }
const _hoisted_116 = ["src"]
const _hoisted_117 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-close" }, null, -1)
const _hoisted_118 = [
  _hoisted_117
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowLeft = _resolveComponent("ArrowLeft")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_Verify = _resolveComponent("Verify")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.loginDisabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.wxLoginState == 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", {
                  class: "login-back",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loginDisabled = true))
                }, [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ArrowLeft)
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.langs('phone.login.goback')), 1)
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.langs('phone.login.wechat.see')), 1),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("img", {
                      style: {"height":"100%","width":"100%"},
                      src: 'https://digital-public-dev.obs.cn-east-3.myhuaweicloud.com' + _ctx.wxQrCode,
                      alt: ""
                    }, null, 8, _hoisted_6)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_el_checkbox, {
                      disabled: "",
                      modelValue: _ctx.agreeChecked,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.agreeChecked = $event)),
                      size: "large"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.langs('phone.login.iAgree')), 1),
                          _createElementVNode("div", {
                            class: "agreementLink",
                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (
                    _ctx.handleGoAgreement(
                      _ctx.lang != 'en'
                        ? 'agreements/user-agreement-zh.html'
                        : 'agreements/user-agreement-en.html',
                      $event,
                    )
                  ), ["stop"]))
                          }, _toDisplayString(_ctx.langs('phone.login.userAgreement')) + "、 ", 1),
                          _createElementVNode("div", {
                            class: "agreementLink",
                            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (
                    _ctx.handleGoAgreement(
                      _ctx.lang != 'en'
                        ? 'agreements/Privacy-Policy-zh.html'
                        : 'agreements/Privacy-Policy-en.html',
                      $event,
                    )
                  ), ["stop"]))
                          }, _toDisplayString(_ctx.langs('phone.login.privary')), 1),
                          _createElementVNode("div", {
                            class: "agreementLink",
                            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (
                    _ctx.handleGoAgreement(
                      _ctx.lang != 'en'
                        ? 'agreements/convention-zh.html'
                        : 'agreements/Privacy-Policy-en.html',
                      $event,
                    )
                  ), ["stop"]))
                          }, _toDisplayString(_ctx.langs('phone.login.convention')), 1)
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ])
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.wxLoginState == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.langs('phone.login.wechat.authorization')), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.loginDisabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (_ctx.isReg && _ctx.registrationStep === 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", {
                  class: "back-button",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.goBackToStep1 && _ctx.goBackToStep1(...args)))
                }, [
                  _hoisted_12,
                  _createTextVNode(" " + _toDisplayString(_ctx.langs('phone.login.backToStep1')), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isReg || _ctx.registrationStep === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                (_ctx.is3Part === false)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.lang == 'en')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_17))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _hoisted_18,
                            _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.isReg ? _ctx.langs('phone.login.userRegister') : _ctx.langs('phone.login.welcome')), 1)
                          ], 64))
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.is3Part)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_20))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.isReg)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: _normalizeClass(["registration-steps", { step2: _ctx.registrationStep === 2 }])
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["step", { active: _ctx.registrationStep >= 1 }])
                }, [
                  _hoisted_21,
                  _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.langs('phone.login.phoneVerification')), 1)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["step", { active: _ctx.registrationStep === 2 }])
                }, [
                  _hoisted_23,
                  _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.langs('phone.login.enterpriseCertification')), 1)
                ], 2)
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.$route.fullPath.includes('school'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createElementVNode("button", {
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isClick = true)),
                  class: _normalizeClass(_ctx.isClick ? _ctx.clickStyle : {})
                }, _toDisplayString(_ctx.langs('phone.login.code')), 3),
                _createElementVNode("button", {
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isClick = false)),
                  class: _normalizeClass(!_ctx.isClick ? _ctx.clickStyle : {})
                }, _toDisplayString(_ctx.langs('phone.login.password')), 3)
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isReg || _ctx.registrationStep === 1)
            ? (_openBlock(), _createBlock(_component_el_form, {
                key: 4,
                class: "form-in",
                model: _ctx.formData,
                rules: _ctx.rules,
                ref: "ruleForm"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    class: "form-li",
                    prop: "username"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.isClick)
                        ? (_openBlock(), _createBlock(_component_el_select, {
                            key: 0,
                            modelValue: _ctx.formData.areaCode,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.formData.areaCode = $event)),
                            filterable: "",
                            "filter-method": _ctx.filterAreaCode,
                            onClick: _ctx.focusAreaCode,
                            onChange: _ctx.changeAreaCode,
                            style: {"width":"32%"}
                          }, {
                            prefix: _withCtx(() => [
                              _createElementVNode("i", {
                                class: _normalizeClass(_ctx.isPhoneBlue)
                              }, null, 2)
                            ]),
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countryCode, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.en,
                                  label: `+${item.code}`,
                                  value: item.en
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", null, [
                                      _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.lang != 'en' ? item.cn : item.en), 1),
                                      _createElementVNode("span", _hoisted_27, "+" + _toDisplayString(item.code), 1)
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "filter-method", "onClick", "onChange"]))
                        : _createCommentVNode("", true),
                      (_ctx.isClick)
                        ? (_openBlock(), _createBlock(_component_el_input, {
                            key: 1,
                            style: {"width":"68%"},
                            autocomplete: "new-password",
                            onKeydown: _withKeys(_ctx.submitForm, ["enter"]),
                            onFocus: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onInputFocus($event, 'phone'))),
                            onBlur: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onInputFocus($event, 'phone'))),
                            modelValue: _ctx.formData.username,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.formData.username = $event)),
                            modelModifiers: { trim: true },
                            placeholder: `${
              _ctx.isClick ? _ctx.language('login.form.phone') : _ctx.language('login.form.username')
            }`
                          }, null, 8, ["onKeydown", "modelValue", "placeholder"]))
                        : (_openBlock(), _createBlock(_component_el_input, {
                            key: 2,
                            autocomplete: "new-password",
                            onKeydown: _withKeys(_ctx.submitForm, ["enter"]),
                            onFocus: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onInputFocus($event, 'phone'))),
                            onBlur: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onInputFocus($event, 'phone'))),
                            modelValue: _ctx.formData.username,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.formData.username = $event)),
                            modelModifiers: { trim: true },
                            placeholder: `${
              _ctx.isClick ? _ctx.language('login.form.phone') : _ctx.language('login.form.username')
            }`
                          }, {
                            prefix: _withCtx(() => [
                              _createElementVNode("i", {
                                class: _normalizeClass(_ctx.isPhoneBlue)
                              }, null, 2)
                            ]),
                            _: 1
                          }, 8, ["onKeydown", "modelValue", "placeholder"]))
                    ]),
                    _: 1
                  }),
                  (!_ctx.isClick)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        class: "form-li",
                        prop: "password"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            autocomplete: "new-password",
                            "show-password": "",
                            onKeydown: _withKeys(_ctx.submitForm, ["enter"]),
                            modelValue: _ctx.formData.password,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.formData.password = $event)),
                            modelModifiers: { trim: true },
                            onFocus: _cache[16] || (_cache[16] = ($event: any) => (_ctx.onInputFocus($event, 'password'))),
                            onBlur: _cache[17] || (_cache[17] = ($event: any) => (_ctx.onInputFocus($event, 'password'))),
                            placeholder: _ctx.langs('phone.login.setPassword'),
                            type: "password"
                          }, {
                            prefix: _withCtx(() => [
                              _createElementVNode("i", {
                                class: _normalizeClass(_ctx.isPasswordBlue)
                              }, null, 2)
                            ]),
                            _: 1
                          }, 8, ["onKeydown", "modelValue", "placeholder"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_form_item, {
                    class: "form-li",
                    prop: "verify"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_28, [
                        _createVNode(_component_el_input, {
                          onFocus: _cache[19] || (_cache[19] = ($event: any) => (_ctx.onInputFocus($event, 'checkCode'))),
                          onBlur: _cache[20] || (_cache[20] = ($event: any) => (_ctx.onInputFocus($event, 'checkCode'))),
                          onKeydown: _withKeys(_ctx.submitForm, ["enter"]),
                          modelValue: _ctx.formData.verify,
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.formData.verify = $event)),
                          modelModifiers: { trim: true },
                          placeholder: _ctx.language('login.form.code')
                        }, _createSlots({
                          prefix: _withCtx(() => [
                            _createElementVNode("i", {
                              class: _normalizeClass(_ctx.ischeckCodeBlue)
                            }, null, 2)
                          ]),
                          _: 2
                        }, [
                          (_ctx.isClick)
                            ? {
                                name: "suffix",
                                fn: _withCtx(() => [
                                  (_ctx.countDown)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.countDown) + " s", 1))
                                    : (_openBlock(), _createElementBlock("span", {
                                        key: 1,
                                        onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.sendMsgFn && _ctx.sendMsgFn(...args))),
                                        style: {"color":"#434af9","cursor":"pointer","font-size":"12px"}
                                      }, _toDisplayString(_ctx.language('login.form.getCode')), 1))
                                ])
                              }
                            : undefined
                        ]), 1032, ["onKeydown", "modelValue", "placeholder"]),
                        (!_ctx.isClick)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                              _createElementVNode("img", {
                                onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.getPictureVerify && _ctx.getPictureVerify(...args))),
                                src: _ctx.verifySrc,
                                alt: "verify"
                              }, null, 8, _hoisted_31)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }),
                  (_ctx.isReg)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 1,
                        class: "form-li",
                        prop: "registerCode"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_32, [
                            _createVNode(_component_el_input, {
                              onFocus: _cache[23] || (_cache[23] = ($event: any) => (_ctx.onInputFocus($event, 'registerCode'))),
                              onBlur: _cache[24] || (_cache[24] = ($event: any) => (_ctx.onInputFocus($event, 'registerCode'))),
                              onKeydown: _withKeys(_ctx.submitForm, ["enter"]),
                              modelValue: _ctx.formData.registerCode,
                              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.formData.registerCode = $event)),
                              modelModifiers: { trim: true },
                              placeholder: 
                _ctx.language('login.form.invitationCode') +
                (_ctx.signupInviteCodeRequired ? ' (必填)' : ' (非必填)')
              
                            }, {
                              prefix: _withCtx(() => [
                                _createElementVNode("i", {
                                  class: _normalizeClass(_ctx.isRegisterCodeBlue)
                                }, null, 2)
                              ]),
                              suffix: _withCtx(() => [
                                (!_ctx.is3Part)
                                  ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                      key: 0,
                                      placement: "bottom"
                                    }, {
                                      content: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_34, [
                                          _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.language('login.tips.text.[1]')), 1),
                                          _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.language('login.tips.text.[2]')), 1),
                                          _hoisted_37
                                        ])
                                      ]),
                                      default: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.language('login.tips.text.[0]')), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_ctx.langs('phone.login.playAgentGet')), 1))
                              ]),
                              _: 1
                            }, 8, ["onKeydown", "modelValue", "placeholder"])
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (!_ctx.isClick)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 2,
                        loading: _ctx.loging,
                        class: "forget-button",
                        onClick: _ctx.setNewPsw,
                        size: "mini",
                        style: {"float":"right"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.langs('phone.login.forgotPassword')), 1)
                        ]),
                        _: 1
                      }, 8, ["loading", "onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["model", "rules"]))
            : _createCommentVNode("", true),
          (_ctx.isReg && _ctx.registrationStep === 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                _createVNode(_component_el_form, {
                  ref: "certificationFormRef",
                  model: _ctx.registrationData,
                  rules: _ctx.certificationRules,
                  "label-position": "top",
                  class: "certification-form"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_40, [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.registrationData.corpName,
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.registrationData.corpName = $event)),
                        placeholder: _ctx.langs('certification.form.corpName.placeholder'),
                        onFocus: _cache[27] || (_cache[27] = ($event: any) => (_ctx.onInputFocus($event, 'corpName'))),
                        onBlur: _cache[28] || (_cache[28] = ($event: any) => (_ctx.onInputFocus($event, 'corpName'))),
                        onKeydown: _withKeys(_ctx.submitForm, ["enter"]),
                        maxlength: "50"
                      }, {
                        prefix: _withCtx(() => [
                          _hoisted_41
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder", "onKeydown"])
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("div", _hoisted_44, [
                          _createTextVNode(_toDisplayString(_ctx.langs('certification.form.businessLicense')), 1),
                          _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.langs('certification.form.businessLicense.required')), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_46, [
                        _createVNode(_component_el_upload, {
                          ref: "businessLicenseUpload",
                          accept: ".jpg,.png",
                          "file-list": _ctx.businessLicenseFileList,
                          "show-file-list": false,
                          action: "",
                          limit: 1,
                          "on-exceed": _ctx.handleBusinessLicenseExceed,
                          "http-request": _ctx.handleBusinessLicenseUpload,
                          "on-remove": _ctx.handleBusinessLicenseRemove,
                          "before-upload": _ctx.beforeBusinessLicenseUpload,
                          disabled: !!_ctx.registrationData.businessLicenseFile,
                          drag: "",
                          class: "upload-dragger"
                        }, {
                          default: _withCtx(() => [
                            (_ctx.businessLicenseUploading)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                  _createVNode(_component_el_icon, { class: "is-loading" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Loading)
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : (_ctx.registrationData.businessLicenseFile)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    class: "uploaded-image-container",
                                    onClick: _cache[32] || (_cache[32] = _withModifiers(() => {}, ["stop"]))
                                  }, [
                                    _createElementVNode("img", {
                                      src: _ctx.registrationData.businessLicensePreviewUrl,
                                      class: "uploaded-image",
                                      onClick: _cache[29] || (_cache[29] = _withModifiers(($event: any) => (_ctx.handlePreview(_ctx.registrationData.businessLicensePreviewUrl)), ["stop"]))
                                    }, null, 8, _hoisted_48),
                                    _createElementVNode("div", _hoisted_49, [
                                      _createElementVNode("i", {
                                        class: "el-icon-zoom-in preview-icon",
                                        onClick: _cache[30] || (_cache[30] = _withModifiers(($event: any) => (_ctx.handlePreview(_ctx.registrationData.businessLicensePreviewUrl)), ["stop"]))
                                      }),
                                      _createElementVNode("i", {
                                        class: "el-icon-delete delete-icon",
                                        onClick: _cache[31] || (_cache[31] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleBusinessLicenseRemove && _ctx.handleBusinessLicenseRemove(...args)), ["stop"]))
                                      })
                                    ])
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                    _createElementVNode("div", _hoisted_51, [
                                      _hoisted_52,
                                      _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.langs('certification.form.businessLicense.upload')), 1),
                                      _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.langs('certification.form.businessLicense.tip')), 1),
                                      _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.langs('certification.form.businessLicense.tip2')), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_56, [
                                      _createElementVNode("div", _hoisted_57, [
                                        _createElementVNode("img", {
                                          src: _imports_4,
                                          class: "example-image",
                                          alt: "示例图片",
                                          onClick: _cache[33] || (_cache[33] = _withModifiers(($event: any) => (
                          _ctx.handlePreviewExample(require('@/assets/images/certification-origin1.png'))
                        ), ["stop"]))
                                        }),
                                        _hoisted_58
                                      ])
                                    ])
                                  ]))
                          ]),
                          _: 1
                        }, 8, ["file-list", "on-exceed", "http-request", "on-remove", "before-upload", "disabled"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_59, [
                      _createElementVNode("div", {
                        class: _normalizeClass(_ctx.authorizationRequired ? 'label-with-required' : 'label-with-optional')
                      }, [
                        _createElementVNode("div", _hoisted_60, [
                          _createTextVNode(_toDisplayString(_ctx.langs('certification.form.authorLetter')) + " ", 1),
                          (_ctx.authorizationRequired)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_61, _toDisplayString(_ctx.langs('certification.form.authorLetter.required')), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_62, _toDisplayString(_ctx.langs('certification.form.authorLetter.optional')), 1))
                        ]),
                        _createElementVNode("a", {
                          href: "#",
                          class: "download-link",
                          onClick: _cache[34] || (_cache[34] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDownloadTemplate && _ctx.handleDownloadTemplate(...args)), ["prevent"]))
                        }, _toDisplayString(_ctx.langs('certification.form.authorLetter.download')), 1)
                      ], 2),
                      _createElementVNode("div", _hoisted_63, [
                        _createVNode(_component_el_upload, {
                          ref: "authorLetterUpload",
                          accept: ".doc,.docx,.pdf",
                          "file-list": _ctx.authorLetterFileList,
                          "show-file-list": false,
                          action: "",
                          limit: 1,
                          "on-exceed": _ctx.handleAuthorLetterExceed,
                          "http-request": _ctx.handleAuthorLetterUpload,
                          "on-remove": _ctx.handleAuthorLetterRemove,
                          "before-upload": _ctx.beforeAuthorLetterUpload,
                          disabled: !!_ctx.registrationData.authorLetterFile,
                          drag: "",
                          class: "upload-dragger"
                        }, {
                          default: _withCtx(() => [
                            (_ctx.authorLetterUploading)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                  _createVNode(_component_el_icon, { class: "is-loading" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Loading)
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : (_ctx.registrationData.authorLetterFile)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    class: "uploaded-file-container",
                                    onClick: _cache[36] || (_cache[36] = _withModifiers(() => {}, ["stop"]))
                                  }, [
                                    _createElementVNode("div", _hoisted_65, [
                                      _hoisted_66,
                                      _createElementVNode("span", _hoisted_67, _toDisplayString(_ctx.registrationData.authorLetterFile.name), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_68, [
                                      _createElementVNode("i", {
                                        class: "el-icon-delete delete-icon",
                                        onClick: _cache[35] || (_cache[35] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleAuthorLetterRemove && _ctx.handleAuthorLetterRemove(...args)), ["stop"]))
                                      })
                                    ])
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_69, [
                                    _createElementVNode("div", _hoisted_70, [
                                      _hoisted_71,
                                      _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.langs('certification.form.authorLetter.upload')), 1),
                                      _createElementVNode("div", _hoisted_73, _toDisplayString(_ctx.langs('certification.form.authorLetter.tip')), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_74, [
                                      _createElementVNode("div", _hoisted_75, [
                                        _createElementVNode("img", {
                                          src: _ctx.getExampleImageUrl(),
                                          class: "example-image",
                                          alt: "示例图片",
                                          onClick: _cache[37] || (_cache[37] = _withModifiers(($event: any) => (_ctx.handlePreviewExample(_ctx.getAuthorLetterPreviewUrl())), ["stop"]))
                                        }, null, 8, _hoisted_76),
                                        _hoisted_77
                                      ])
                                    ])
                                  ]))
                          ]),
                          _: 1
                        }, 8, ["file-list", "on-exceed", "http-request", "on-remove", "before-upload", "disabled"])
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["model", "rules"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(["agreement", [_ctx.lang != 'en' ? 'agreementZh' : '', _ctx.isReg ? 'agreement-reg' : '']])
          }, [
            _createVNode(_component_el_checkbox, {
              modelValue: _ctx.agreeChecked,
              "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (_ctx.agreeChecked = $event)),
              size: "large"
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_78, [
              _createElementVNode("span", null, _toDisplayString(_ctx.language('login.agreement')), 1),
              _createElementVNode("span", {
                class: "agreementLink",
                onClick: _cache[39] || (_cache[39] = _withModifiers(($event: any) => (
              _ctx.handleGoAgreement(
                _ctx.lang != 'en'
                  ? 'agreements/user-agreement-zh.html'
                  : 'agreements/user-agreement-en.html',
                $event,
              )
            ), ["stop"]))
              }, _toDisplayString(_ctx.language('phone.login.userAgreement')) + "、 ", 1),
              (_ctx.lang == 'en')
                ? (_openBlock(), _createElementBlock("span", _hoisted_79, "and"))
                : _createCommentVNode("", true),
              _createElementVNode("span", {
                class: "agreementLink",
                onClick: _cache[40] || (_cache[40] = _withModifiers(($event: any) => (
              _ctx.handleGoAgreement(
                _ctx.lang != 'en'
                  ? 'agreements/Privacy-Policy-zh.html'
                  : 'agreements/Privacy-Policy-en.html',
                $event,
              )
            ), ["stop"]))
              }, _toDisplayString(_ctx.language('login.agreement.[1]')), 1),
              _createElementVNode("span", _hoisted_80, _toDisplayString(_ctx.language('login.agreement.and')), 1),
              _createElementVNode("span", {
                class: "agreementLink",
                onClick: _cache[41] || (_cache[41] = _withModifiers(($event: any) => (
              _ctx.handleGoAgreement(
                _ctx.lang != 'en' ? 'agreements/convention-zh.html' : 'agreements/convention-en.html',
                $event,
              )
            ), ["stop"]))
              }, _toDisplayString(_ctx.language('phone.login.convention')), 1)
            ]),
            (![86, 852, 853, 886].includes(_ctx.areaCode))
              ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                  _createVNode(_component_el_checkbox, {
                    modelValue: _ctx.agreeMsgChecked,
                    "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => (_ctx.agreeMsgChecked = $event)),
                    size: "large"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.language('login.agreeMsg')), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true)
          ], 2),
          _createVNode(_component_el_button, {
            loading: _ctx.loging,
            class: "login-button",
            onClick: _ctx.submitForm,
            type: "primary",
            size: "medium"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.wxLoginState == 2
            ? _ctx.language('login.btn.bindPhone')
            : _ctx.isReg
            ? _ctx.registrationStep === 1
              ? _ctx.lang === 'en'
                ? 'Next'
                : '下一步'
              : _ctx.lang === 'en'
              ? 'Register'
              : '注册'
            : _ctx.language('login.btn.login')), 1)
            ]),
            _: 1
          }, 8, ["loading", "onClick"]),
          (_ctx.is3Part === false)
            ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                (_ctx.isReg)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_83, [
                      _createTextVNode(_toDisplayString(_ctx.language('login.account.have')), 1),
                      _createElementVNode("span", {
                        class: "reg-btn",
                        onClick: _cache[43] || (_cache[43] = 
//@ts-ignore
(...args) => (_ctx.handleToggleReg && _ctx.handleToggleReg(...args)))
                      }, _toDisplayString(_ctx.language('login.account.login')), 1)
                    ]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (_ctx.isClick)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                            _createElementVNode("span", _hoisted_85, [
                              _createTextVNode(_toDisplayString(_ctx.language('login.account.no')) + " ", 1),
                              (_ctx.lang != 'en')
                                ? (_openBlock(), _createBlock(_component_el_popover, {
                                    key: 0,
                                    placement: "right",
                                    width: "400",
                                    trigger: "hover"
                                  }, {
                                    reference: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_87, [
                                        _createElementVNode("span", _hoisted_88, _toDisplayString(_ctx.language('login.account.reg')), 1)
                                      ])
                                    ]),
                                    default: _withCtx(() => [
                                      _hoisted_86
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
              ]))
            : _createCommentVNode("", true),
          (_ctx.$route.path.includes('huaweiyun'))
            ? (_openBlock(), _createElementBlock("div", {
                key: 7,
                onClick: _cache[44] || (_cache[44] = 
//@ts-ignore
(...args) => (_ctx.handleHuaweiyunLogin && _ctx.handleHuaweiyunLogin(...args))),
                class: "huawei-login"
              }, [
                _createElementVNode("div", _hoisted_89, _toDisplayString(_ctx.langs('phone.login.otherAccount')), 1),
                _hoisted_90,
                _createElementVNode("div", _hoisted_91, _toDisplayString(_ctx.langs('phone.login.hw')), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.wxLoginState != 2 && _ctx.lang != 'en' && false)
            ? (_openBlock(), _createElementBlock("div", {
                key: 8,
                class: "webchat-con",
                style: _normalizeStyle({ 'margin-top': _ctx.isReg ? '20px' : '80px' })
              }, [
                _createElementVNode("div", _hoisted_92, [
                  _hoisted_93,
                  _createElementVNode("div", _hoisted_94, _toDisplayString(_ctx.langs('phone.login.thirdParty')), 1),
                  _hoisted_95
                ]),
                _createVNode(_component_el_tooltip, {
                  effect: "dark",
                  class: "box-item",
                  content: _ctx.langs('phone.login.wechat'),
                  placement: "top"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "wechat-icon",
                      onClick: _cache[45] || (_cache[45] = 
//@ts-ignore
(...args) => (_ctx.wechatLogin && _ctx.wechatLogin(...args)))
                    })
                  ]),
                  _: 1
                }, 8, ["content"])
              ], 4))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.forgetPswDisabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
          _hoisted_97,
          _createElementVNode("div", _hoisted_98, [
            _createElementVNode("span", {
              class: "span-login",
              onClick: _cache[46] || (_cache[46] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
            }, _hoisted_100),
            _createElementVNode("span", _hoisted_101, _toDisplayString(_ctx.langs('phone.login.forgotPassword')), 1)
          ]),
          _createVNode(_component_el_form, {
            class: "form-in",
            model: _ctx.formData,
            rules: _ctx.forgetRules,
            ref: "reRuleForm"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                class: "form-li",
                prop: "username"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    onKeydown: _withKeys(_ctx.submitNewPsw, ["enter"]),
                    modelValue: _ctx.formData.username,
                    "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => (_ctx.formData.username = $event)),
                    modelModifiers: { trim: true },
                    placeholder: _ctx.langs('login.form.phone')
                  }, {
                    prefix: _withCtx(() => []),
                    _: 1
                  }, 8, ["onKeydown", "modelValue", "placeholder"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                class: "form-li",
                prop: "verify"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_102, [
                    _createVNode(_component_el_input, {
                      class: "verify-input",
                      onKeydown: _withKeys(_ctx.submitNewPsw, ["enter"]),
                      modelValue: _ctx.formData.verify,
                      "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => (_ctx.formData.verify = $event)),
                      modelModifiers: { trim: true },
                      placeholder: _ctx.langs('login.form.code')
                    }, {
                      prefix: _withCtx(() => []),
                      _: 1
                    }, 8, ["onKeydown", "modelValue", "placeholder"]),
                    _createElementVNode("div", _hoisted_103, [
                      _createElementVNode("div", _hoisted_104, [
                        _withDirectives(_createElementVNode("span", null, _toDisplayString(_ctx.countDown) + " s", 513), [
                          [_vShow, _ctx.countDown]
                        ])
                      ]),
                      _createVNode(_component_el_tooltip, {
                        class: "item",
                        effect: "light",
                        content: _ctx.langs('phone.login.sendCode'),
                        placement: "right"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            circle: "",
                            type: "primary",
                            icon: "el-icon-message",
                            disabled: _ctx.countDown ? true : false,
                            onClick: _ctx.sendMsgFn
                          }, null, 8, ["disabled", "onClick"])
                        ]),
                        _: 1
                      }, 8, ["content"])
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                class: "form-li",
                prop: "password"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    "show-password": "",
                    onKeydown: _withKeys(_ctx.submitNewPsw, ["enter"]),
                    modelValue: _ctx.formData.password,
                    "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => (_ctx.formData.password = $event)),
                    modelModifiers: { trim: true },
                    placeholder: _ctx.langs('phone.login.setNewPassword'),
                    type: "password"
                  }, {
                    prefix: _withCtx(() => []),
                    _: 1
                  }, 8, ["onKeydown", "modelValue", "placeholder"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"]),
          _createVNode(_component_el_button, {
            loading: _ctx.loging,
            class: "login-button",
            onClick: _ctx.submitNewPsw,
            type: "primary",
            size: "medium"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.langs('phone.login.confirm')), 1)
            ]),
            _: 1
          }, 8, ["loading", "onClick"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isregist)
      ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
          _createElementVNode("span", _hoisted_106, _toDisplayString(_ctx.langs('phone.login.userRegister')), 1),
          _createElementVNode("span", _hoisted_107, _toDisplayString(_ctx.langs('phone.login.changeEntity')), 1),
          _createElementVNode("div", _hoisted_108, [
            _createVNode(_component_el_button, {
              loading: _ctx.loging,
              class: "register_btns_one",
              onClick: _ctx.createTourist,
              size: "medium"
            }, null, 8, ["loading", "onClick"]),
            _createVNode(_component_el_button, {
              loading: _ctx.loging,
              class: "register_btns_more",
              onClick: _ctx.createNewcorpPage,
              size: "medium"
            }, null, 8, ["loading", "onClick"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isNotNewUser)
      ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
          _hoisted_110,
          _createElementVNode("div", _hoisted_111, [
            _createElementVNode("span", {
              class: "span-login",
              onClick: _cache[50] || (_cache[50] = 
//@ts-ignore
(...args) => (_ctx.goBackReg && _ctx.goBackReg(...args)))
            }, _hoisted_113),
            _createElementVNode("span", _hoisted_114, _toDisplayString(_ctx.langs('phone.login.registerCompany')), 1)
          ]),
          _createVNode(_component_el_form, {
            class: "form-in",
            model: _ctx.registData,
            rules: _ctx.registrules,
            ref: "registruleForm"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                class: "form-li",
                prop: "corpName"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.registData.corpName,
                    "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => (_ctx.registData.corpName = $event)),
                    modelModifiers: { trim: true },
                    maxlength: "50",
                    placeholder: _ctx.langs('phone.login.rule[1]')
                  }, {
                    prefix: _withCtx(() => []),
                    _: 1
                  }, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                class: "form-li",
                prop: "linkman"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.registData.linkman,
                    "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => (_ctx.registData.linkman = $event)),
                    modelModifiers: { trim: true },
                    maxlength: "20",
                    placeholder: _ctx.langs('phone.login.rule[2]')
                  }, {
                    prefix: _withCtx(() => []),
                    _: 1
                  }, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"]),
          _createVNode(_component_el_button, {
            loading: _ctx.loging,
            class: "login-button",
            onClick: _ctx.createNewcorp,
            type: "primary",
            size: "medium"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.langs('mainTip.logout.confirm')), 1)
            ]),
            _: 1
          }, 8, ["loading", "onClick"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Verify, {
      lang: _ctx.lang,
      areaCode: _ctx.areaCode,
      imgSize: { width: '400px', height: '200px' },
      ref: "verify",
      onSuccess: _ctx.onSuccess
    }, null, 8, ["lang", "areaCode", "onSuccess"]),
    (_ctx.previewDialogVisible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 5,
          class: "preview-dialog-overlay",
          onClick: _cache[55] || (_cache[55] = ($event: any) => (_ctx.previewDialogVisible = false))
        }, [
          _createElementVNode("div", {
            class: "preview-dialog-container",
            onClick: _cache[54] || (_cache[54] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", _hoisted_115, [
              _createElementVNode("img", {
                src: _ctx.previewImageUrl,
                class: "preview-image",
                alt: "预览图片"
              }, null, 8, _hoisted_116),
              _createElementVNode("button", {
                class: "preview-close-button",
                onClick: _cache[53] || (_cache[53] = ($event: any) => (_ctx.previewDialogVisible = false))
              }, _hoisted_118)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}